var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import AnimateHeight from 'react-animate-height';
import MenuLink from "./menuLink";
var MenuPortalHowTo = /** @class */ (function (_super) {
    __extends(MenuPortalHowTo, _super);
    function MenuPortalHowTo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false
        };
        return _this;
    }
    MenuPortalHowTo.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, title = _a.title, clickVideos = _a.clickVideos, clickGuides = _a.clickGuides;
        var idValue = id ? id : "menuPortalItem";
        return (React.createElement("li", { id: idValue, className: "nav-item" },
            React.createElement("a", { className: "nav-link", href: "javascript:void(0)", onClick: function () { return _this.setState({ isOpen: !_this.state.isOpen }); } },
                React.createElement("i", { className: "iconfont icon-videoshow" }),
                title,
                React.createElement("b", { className: "caret" })),
            React.createElement("div", { id: "portalHowto" },
                React.createElement(AnimateHeight, { height: this.state.isOpen ? 'auto' : 0 },
                    React.createElement("ul", { className: "nav sub-menu", onClick: function () { return _this.setState({ isOpen: false }); } },
                        React.createElement(MenuLink, { to: "/videoList", label: "Videos", onClick: clickVideos }),
                        React.createElement(MenuLink, { to: "/guideList", label: "Guides", onClick: clickGuides }))))));
    };
    return MenuPortalHowTo;
}(Component));
export { MenuPortalHowTo };
export default MenuPortalHowTo;
